var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineMailIncoming({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15626_12103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.42847 5.71387L9.9999 9.2853M9.9999 9.2853L13.5713 5.71387M9.9999 9.2853V0.713867",
    stroke: "#56585A",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1428 6.42773C17.5216 6.42773 17.885 6.57824 18.1529 6.84615C18.4208 7.11406 18.5713 7.47743 18.5713 7.85631V17.8563C18.5713 18.2352 18.4208 18.5985 18.1529 18.8665C17.885 19.1344 17.5216 19.2849 17.1428 19.2849H2.85704C2.47816 19.2849 2.11479 19.1344 1.84689 18.8665C1.57898 18.5985 1.42847 18.2352 1.42847 17.8563V7.85631C1.42847 7.47743 1.57898 7.11406 1.84689 6.84615C2.11479 6.57824 2.47816 6.42773 2.85704 6.42773",
    stroke: "#56585A",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.42847 8.22852L9.99989 14.2857L18.5713 8.22852",
    stroke: "#56585A",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15626_12103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineMailIncoming);
export default __webpack_public_path__ + "static/media/streamline_mail-incoming.c85e8ef283c471ab3454374f939b2574.svg";
export { ForwardRef as ReactComponent };